export const SEO_TITLE_SUGGESTION_TYPE = 'SEO_TITLE';
export const SEO_DESCRIPTION_SUGGESTION_TYPE = 'SEO_DESCRIPTION';
export const HEADER_SUGGESTION_TYPE = 'HEADER';
export const CONTENT_SUGGESTION_TYPE = 'CONTENT';

export const PAGE_SUGGESTION_TYPES = [SEO_TITLE_SUGGESTION_TYPE, SEO_DESCRIPTION_SUGGESTION_TYPE];
export const CONTENT_NODE_SUGGESTION_TYPES = [HEADER_SUGGESTION_TYPE, CONTENT_SUGGESTION_TYPE];

export const CONTENT_SUGGESTION_TYPES = [
  SEO_TITLE_SUGGESTION_TYPE,
  SEO_DESCRIPTION_SUGGESTION_TYPE,
  HEADER_SUGGESTION_TYPE,
  CONTENT_SUGGESTION_TYPE,
];

export const SEO_TITLE_SUGGESTION_SET_TITLE = 'SEO Title';
export const SEO_DESCRIPTION_SUGGESTION_SET_TITLE = 'SEO Description';
export const DEFAULT_SUGGESTION_SET_TITLE = 'Content Suggestions';
